import { useContext } from "react";
import { CartContext } from "../../context/CartContext";
import CartItem from "../CartItem/CartItem";
import { Link } from "react-router-dom";

const Cart = () => {
  const { cart, clearCart } = useContext(CartContext);
  const totalQuantity = cart.reduce((total, item) => total + item.quantity, 0);
  const total = cart.reduce((total, item) => total + item.price * item.quantity, 0);

  if (totalQuantity === 0) {
    return (
      <section className="flex flex-col items-center text-center p-6">
        <h1 className="text-xl font-semibold mb-4">No hay productos en tu carrito</h1>
        <Link to="/" className="Option">
          <button className="rounded-full border border-gray-300 py-2 px-5 font-medium transition hover:bg-black hover:text-white">
            Volver a la tienda
          </button>
        </Link>
      </section>
    );
  }

  return (
    <section className="container mx-auto px-4 mt-10 mb-20">
      <div className="flex flex-col lg:flex-row shadow-md bg-white rounded-xl overflow-hidden">
        
        {/* 🛒 Lista de productos */}
        <div className="w-full lg:w-3/4 px-4 sm:px-8 py-8">
          <div className="flex flex-col sm:flex-row justify-between border-b pb-4 sm:pb-8">
            <h1 className="font-semibold text-xl sm:text-2xl">Carrito de Reservas</h1>
            <h2 className="font-semibold text-lg sm:text-2xl mt-2 sm:mt-0">{totalQuantity} Items</h2>
          </div>

          {/* Encabezado del carrito */}
          <div className="hidden sm:flex justify-between mt-8 mb-4 text-gray-600 text-xs uppercase">
            <h3 className="font-semibold w-2/5">Detalle</h3>
            <h3 className="font-semibold w-1/5 text-center">Cantidad</h3>
            <h3 className="font-semibold w-1/5 text-center">Precio</h3>
            <h3 className="font-semibold w-1/5 text-center">Total</h3>
          </div>

          {/* Items */}
          <div className="flex flex-col divide-y">
            {cart.map((p) => (
              <CartItem key={p.id} {...p} />
            ))}
          </div>

          {/* Botones */}
          <div className="flex flex-col sm:flex-row items-center justify-between mt-8 gap-3">
            <Link
              to="/"
              className="inline-flex items-center font-semibold text-sm text-black hover:text-green-600 transition"
            >
              <svg className="inline mr-2 w-4" viewBox="0 0 448 512">
                <path d="M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z" />
              </svg>
              Volver a la tienda
            </Link>

            <button
              className="rounded-full border border-gray-300 py-2 px-5 text-base font-medium transition hover:bg-black hover:text-white"
              onClick={() => clearCart()}
            >
              Borrar todos los productos
            </button>
          </div>
        </div>

        {/* 🧾 Resumen */}
        <div className="w-full lg:w-1/4 bg-gray-50 px-6 sm:px-8 py-8 border-t lg:border-t-0 lg:border-l">
          <h1 className="font-semibold text-xl sm:text-2xl border-b pb-4">Resumen del pedido</h1>

          <div className="flex justify-between mt-6 mb-4 text-sm">
            <span className="font-semibold uppercase">{totalQuantity} Items</span>
            <span className="font-semibold">{total} $</span>
          </div>

          <div className="py-6">
            <label htmlFor="promo" className="font-semibold block mb-2 text-sm uppercase">
              Promo
            </label>
            <input
              type="text"
              id="promo"
              placeholder="Ingrese su código"
              className="p-2 text-sm w-full border border-gray-300 rounded"
            />
          </div>

          <button className="rounded-full w-full border border-gray-300 px-5 py-2 text-base font-medium transition hover:bg-black hover:text-white">
            Aplicar
          </button>

          <div className="border-t mt-8 pt-4">
            <div className="flex font-semibold justify-between text-sm uppercase mb-4">
              <span>Costo total</span>
              <span>{total} $</span>
            </div>
            <Link to="/checkout">
              <button className="rounded-full border border-green-600 py-3 px-5 text-lg font-semibold text-white bg-green-600 transition hover:bg-green-700 w-full shadow-md uppercase">
                Finalizar Pedido
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cart;
